module.exports = __webpack_public_path__ + "img/doc.4a6b0330.png";